import { shape } from 'prop-types';

import amountPropTypes from './amountPropTypes';

const otherFundsModalPropTypes = shape({
  previous: amountPropTypes,
  period: amountPropTypes,
  remainder: amountPropTypes,
});

export default otherFundsModalPropTypes;
